import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Spinner from './Spinner';
import { releaseStock } from '../utils/api';

const StockRelease: React.FC = () => {
    const [productId, setProductId] = useState<string>('');
    const [quantity, setQuantity] = useState<number>(1);
    const [reference, setReference] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleReleaseStock = async () => {
        if (!productId.trim()) {
            toast.error("Product ID is required.");
            return;
        }

        if (quantity <= 0) {
            toast.error("Release quantity must be positive.");
            return;
        }

        const productIdNum = parseInt(productId, 10);
        if (isNaN(productIdNum)) {
            toast.error("Invalid Product ID.");
            return;
        }

        setLoading(true);
        try {
            const response = await releaseStock(productIdNum, quantity, reference);
            toast.success(response.message || `Successfully released stock for product ID ${productIdNum}.`);
            setProductId('');
            setQuantity(1);
            setReference('');
        } catch (err: any) {
            toast.error(err.message || "Failed to release stock.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            {loading && <Spinner />}
            <div className="mb-4">
                <label htmlFor="releaseProductId" className="block text-sm font-medium text-gray-700 mb-1">Product ID</label>
                <input type="text" id="releaseProductId" value={productId} onChange={(e) => setProductId(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="Enter Product ID" />
            </div>
            <div className="mb-4">
                <label htmlFor="releaseQuantity" className="block text-sm font-medium text-gray-700 mb-1">Quantity to Release</label>
                <input type="number" id="releaseQuantity" value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 1)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" min="1" />
            </div>
            <div className="mb-6">
                <label htmlFor="releaseReference" className="block text-sm font-medium text-gray-700 mb-1">Reference (Optional)</label>
                <input type="text" id="releaseReference" value={reference} onChange={(e) => setReference(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="e.g., Order #123" />
            </div>
            <button onClick={handleReleaseStock} disabled={loading} className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition duration-150 disabled:opacity-50">
                {loading ? 'Processing...' : 'Release Stock'}
            </button>
        </div>
    );
};

export default StockRelease;